import { useEffect, useState, Fragment } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery, gql } from '@apollo/client';
import {
    Header,
    Icon,
} from 'semantic-ui-react';

import { JoyyaHeader } from '../../../../components/JoyyaHeader';
import styles from './TeacherClassRecord.module.css';

const GET_PERSON = gql`
    query User($personId: Int!) {
        user(personId: $personId) {
            id
            name
            records {
                id
                connectionScore
                confidenceScore
                contributionScore
                completionStatus
                endCapacityScore
                notes
                startCapacityScore
                teacherComment
                course {
                    SKU
                    id
                }
            }
        }
    }
`;

const TeacherPersonRecord = () => {
    let navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const { loading, error, data, refetch } = useQuery(GET_PERSON, {
        variables: { personId: parseInt(id || '0', 10) }
    });

    return (
        <Fragment>
            <JoyyaHeader />
            {/* Summary of status */}
            <div className='mobile-frame'>
                <Header as='h2'>
                    <span className={styles.header}>
                        <Icon name='arrow left' className={styles.pointer} onClick={() => navigate(-1)} />
                        Records for {!loading && !error && data.user.name}
                    </span>
                </Header>

                {loading ? (<p>Loading...</p>) : error ? (<p>Error loading records.</p>) : (
                    <div>
                        <table
                            style={{ width: '100%', border: '1px solid #ddd', borderCollapse: 'collapse', borderRadius: '4px', overflow: 'hidden' }}
                        >
                            <thead style={{ textAlign: 'left', backgroundColor: '#f2f2f2' }}>
                                <tr>
                                    <th>SKU</th>
                                    <th>Cap. Start</th>
                                    <th>Cap. End</th>
                                    <th>Conn.</th>
                                    <th>Cont.</th>
                                    <th>Conf.</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.user.records.map((record: any) => (
                                    <tr key={record.id} style={record.completionStatus === 'DROPPED' ? { backgroundColor: '#f8d7da' } : record.completionStatus === 'GRADUATE' ? { backgroundColor: '#d4edda' } : {}}>
                                        <td>{record.course.SKU}</td>
                                        <td>{record.startCapacityScore}</td>
                                        <td>{record.endCapacityScore}</td>
                                        <td>{record.connectionScore}</td>
                                        <td>{record.contributionScore}</td>
                                        <td>{record.confidenceScore}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

            </div>
        </Fragment>
    );
}

export { TeacherPersonRecord };
